module.exports = __webpack_public_path__ + "img/04_full.1419167f.jpg";